"use client";

import React from "react";
import { TOP_BANNER_BUTTON_TYPES } from "lib/constants/topBanner";
import { TopBannerContent } from "./topBannerContent";
import { useTopBanner } from "./hooks/useTopBanner";

export const TopBanner: React.FC = () => {
  const {
    variant,
    bannerData,
    handleDismiss,
    trackButtonClick,
    shouldShow: shouldDisplayTopBanner,
  } = useTopBanner();

  if (!shouldDisplayTopBanner || !bannerData) return null;

  const bd = bannerData;

  return (
    <TopBannerContent
      variant={variant}
      heading={bd.heading}
      subheading={bd.subheading}
      primaryButtonLabel={bd.primaryButtonLabel}
      primaryButtonHref={bd.primaryButtonUrl}
      primaryButtonOnClick={() =>
        trackButtonClick(TOP_BANNER_BUTTON_TYPES.PRIMARY)
      }
      secondaryButtonLabel={bd.secondaryButtonLabel}
      secondaryButtonHref={bd.secondaryButtonUrl ?? undefined}
      secondaryButtonOnClick={() =>
        trackButtonClick(TOP_BANNER_BUTTON_TYPES.SECONDARY)
      }
      onClose={handleDismiss}
    />
  );
};
